import { Chip, Typography } from "@mui/material";
import { makeTintedBackgroundFromColor } from "@entrilia/shared/utilities/colorHelper";

const DraftStatus = () => {
  return (
    <Chip
      label={
        <Typography variant="caption" sx={{ fontWeight: 500 }}>
          Template:
          <Typography variant="caption" color="textSecondary" sx={{ ml: 0.5, fontWeight: "inherit" }}>
            Draft
          </Typography>
        </Typography>
      }
      sx={(t) => ({ bgcolor: makeTintedBackgroundFromColor(t, t.palette.text.secondary) })}
    />
  );
};

export default DraftStatus;
